import React from 'react'
import { Input, Menu, Icon, Grid, Header, Button } from 'semantic-ui-react'
import _ from 'lodash'

const styles = {
  menu: {
    maxHeight: 'calc(100vh - 350px)',
    overflow: 'auto',
    width: '100%'
  },
  item: {
    padding: '13px 10px',
    borderRadius: 0
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  itemName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
  checkContainer: {
    display: 'flex',
    width: 20,
    justifyContent: 'flex-end',
    marginLeft: 5,
  },
}


class ItemAndOptionPicker extends React.PureComponent {
  state = {
    searchItem: '',
    searchOption: '',
  }

  renderItems = () => {
    // const { searchItem } = this.state
    // const { items, selectedItemKeys, onItemClick } = this.props

    // let displayItems = Object.values(items).filter(item => {
    //   const itemName = (item.name || '').toLowerCase()
    //   const searchText = searchItem.toLowerCase().trim()

    //   return itemName.includes(searchText)
    // })

    // displayItems = _.sortBy(displayItems, 'key')

    const { searchItem } = this.state
    const { items, selectedItemKeys, onItemClick, onSelectAllPress } = this.props

    let displayItems = []

    _.forEach(items, (item, itemKey) => {
      const itemName = (item.name || '').toLowerCase()
      const searchText = searchItem.toLowerCase().trim()

      if (itemName.includes(searchText)) {
        displayItems.push({ ...item, key: itemKey })
      }
    })

    displayItems = _.sortBy(displayItems, 'key')
    const isAllItemSelected = selectedItemKeys.length === displayItems.length

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header>Items List</Header>
          <div style={{ marginTop: -5 }}>
            <Button
              size='mini'
              onClick={() => onSelectAllPress(isAllItemSelected ? 'deselect' : 'select')}
            >
              { isAllItemSelected ? 'Deselect all' : 'Select All' }
            </Button>
          </div>
        </div>
        <Input
          type="text"
          placeholder="Search"
          name="search-item"
          onChange={e => this.setState({ searchItem: e.target.value })}
          icon="search"
          style={{ width: '100%', marginTop: 10 }}
        />
        <Menu vertical style={styles.menu}>
          {
            displayItems.map(item => (
              <Menu.Item
                key={item.key}
                active={selectedItemKeys && selectedItemKeys.includes(item.key)}
                onClick={() => onItemClick(item.key)}
                style={styles.item}
              >
                <div style={styles.itemRow} >
                  <div style={styles.itemName}>
                    <Icon
                      name='clipboard check'
                      style={{ color: _.size(item.options) > 0 ? 'gray' : 'transparent' }}
                    />
                    {item.name}
                  </div>
                  {
                    selectedItemKeys.includes(item.key) && (
                      <div style={styles.checkContainer} >
                        <Icon name="check" color="green" />
                      </div>
                    )
                  }
                </div>
              </Menu.Item>
            ))
          }
        </Menu>
      </div>
    )
  }

  renderOptions = () => {
    const { searchOption } = this.state
    const { itemOptions, selectedItemOptionIds, onItemOptionClick } = this.props

    let displayOptions = Object.values(itemOptions).filter(option => {
      const optionName = (option.name || '').toLowerCase()
      const searchText = searchOption.toLowerCase().trim()

      return optionName.includes(searchText)
    })

    displayOptions = _.sortBy(displayOptions, 'id')

    return (
      <div>
        <Header>Items Options List</Header>
        <Input
          type="text"
          placeholder="Search"
          name="search-option"
          onChange={e => this.setState({ searchOption: e.target.value })}
          icon="search"
          style={{ width: '100%', marginTop: 10 }}
        />
        <Menu vertical style={styles.menu}>
          {
            displayOptions.map(option => (
              <Menu.Item
                key={option.id}
                active={selectedItemOptionIds && selectedItemOptionIds.includes(option.id)}
                onClick={() => onItemOptionClick(option.id)}
                style={styles.item}
              >
                <div style={styles.itemRow} >
                  <div style={styles.itemName}>
                    {option.name}
                  </div>
                  {
                    selectedItemOptionIds.includes(option.id) && (
                      <div style={styles.checkContainer} >
                        <Icon name="check" color="green" />
                      </div>
                    )
                  }
                </div>
              </Menu.Item>
            ))
          }
        </Menu>
      </div>
    )
  }

  render() {
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>{ this.renderItems() }</Grid.Column>
          <Grid.Column>{ this.renderOptions() }</Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default ItemAndOptionPicker



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemOptionLinker/picker.js